import { useRef, useEffect, useLayoutEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import parse from "html-react-parser";
import { Carousel } from "react-responsive-carousel";
import { parseISO, format } from "date-fns";
import { es, enGB } from "date-fns/esm/locale";

import { CarruselImagesContainer } from "components/carrusel-images-container";
import { VideoContainer } from "components/video-container";

import useWindowDimensions from "hoc/useWindowDimensions";

import back from "../assets/img/back.png";
import backWhite from "../assets/img/back-white.png";
import { Products } from "components/produts";
import { CarruselVideosContainer } from "components/carrusel-videos-container";

const myObject = {
  pdf: {
    en: "DOWNLOAD TEXT",
    es: "DESCARGAR TEXTO",
  },
  editorial: {
    en: "GO TO EDITORIAL",
    es: "IR A EDITORIAL",
  },
};

export const DetailPage = ({
  originURL,
  country,
  detail,
  locale,
  onBack,
  showDraft,
  darkMode,
  isShowroom,
}) => {
  const { width } = useWindowDimensions();
  const [naturalHeightImage, setNaturalHeightImage] = useState(0);
  const [widthDiv, setWidthDiv] = useState(1920);
  const divRef = useRef();
  const [isDarkMode, setIsDarkMode] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    window.parent.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches &&
      darkMode
    ) {
      setIsDarkMode(true);
    }
  }, []);

  const handleOnLoadImage = ({ target: img }) => {
    setNaturalHeightImage(img.naturalHeight);
  };

  const showRibbon = () => {
    if (detail?.state === "DRAFT" || detail?.state === "PUBLISH_WITH_DRAFT") {
      if (showDraft) {
        return true;
      }
    }
    return false;
  };
  const handleLoadDiv = () => {
    setWidthDiv(
      width > 919 ? divRef.current.clientWidth : divRef.current.clientWidth - 40
    );
  };

  return (
    <>
      {detail && (
        <div
          className="detailPage-container"
          ref={divRef}
          onLoad={handleLoadDiv}
        >
          <div className="title-container">
            <div onClick={onBack}>
              <img src={isDarkMode ? backWhite : back} alt={"back"} />
            </div>
            <div>
              <p className="title">{detail?.content?.title}</p>
            </div>

            <p className="date">
              {locale === "es"
                ? format(parseISO(detail?.content?.date), "dd LLLL, yyyy", {
                    locale: es,
                  })
                : format(parseISO(detail?.content?.date), "LLLL dd, yyyy", {
                    locale: enGB,
                  })}
            </p>
          </div>

          <div
            className="principal-container"
            style={{ maxHeight: width > 919 && naturalHeightImage }}
          >
            <div className="image-container">
              {showRibbon() && (
                <div
                  className={`ribbon ribbon-top-left ${
                    detail?.state === "PUBLISH_WITH_DRAFT" ? "ribbon-green" : ""
                  }`}
                >
                  <span>DRAFT</span>
                </div>
              )}
              {detail?.content?.mainMultimedia?.length > 1 ? (
                <Carousel
                  showArrows={false}
                  showStatus={false}
                  showThumbs={false}
                  emulateTouch={true}
                >
                  {detail?.content?.mainMultimedia?.map((image, index) => (
                    <div key={`principal-${index}`}>
                      <img
                        src={image}
                        alt={"news background"}
                        onLoad={handleOnLoadImage}
                      />
                    </div>
                  ))}
                </Carousel>
              ) : (
                <>
                  <div className="image-not-carrusel">
                    {showRibbon() && (
                      <div
                        className={`ribbon ribbon-top-left ${
                          detail?.state === "PUBLISH_WITH_DRAFT"
                            ? "ribbon-green"
                            : ""
                        }`}
                      >
                        <span>DRAFT</span>
                      </div>
                    )}
                    <img
                      src={detail?.content?.mainMultimedia[0]}
                      onLoad={handleOnLoadImage}
                      alt={"news background"}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="text-container">
              <p className="subtitle">{detail?.content?.subtitle}</p>
              <div className={`text ${darkMode ? "darkMode" : ""}`}>
                {parse(detail?.content?.textContent)}
              </div>

              <div className="buttons-container">
                {detail?.content?.links?.map((link, index) => {
                  return (
                    <div
                      className="button"
                      role={"button"}
                      key={`link-${index}`}
                    >
                      <a
                        href={link?.href}
                        target="_blank"
                        rel="noreferrer"
                        className={darkMode ? "darkMode" : ""}
                      >
                        <span>{myObject[link?.type][locale]}</span>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {detail?.content?.multimedia?.map((multi, index) => {
            return multi?.type === "Images" ? (
              <CarruselImagesContainer
                title={multi.title}
                images={multi.content}
                key={`images-${index}`}
              />
            ) : (
              <>
                {multi.content.length > 1 ? (
                  <CarruselVideosContainer
                    title={multi.title}
                    videos={multi.content}
                    key={`video-${index}`}
                    width={widthDiv}
                  />
                ) : (
                  <VideoContainer
                    title={multi.title}
                    video={multi.content[0]}
                    key={`video-${index}`}
                  />
                )}
              </>
            );
          })}

          {detail?.content?.category?.id && (
            <Products
              originURL={originURL}
              country={country}
              locale={locale}
              id={detail?.content?.category?.id}
              baseImagePath={detail?.content?.category?.baseImagePath}
              baseZaraPath={detail?.content?.category?.baseZaraPath}
              isShowroom={isShowroom}
            />
          )}
        </div>
      )}
    </>
  );
};
